// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-fluid {
  background-color: #f8fafb;
  padding: 0;
  border-radius: 15px;
}

.group-section {
  background: white;
  padding: 0 20px;
  border: 1px solid #dee2e6;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}

.group-section-profile {
  background: white;
  padding: 0 20px;
  border: 1px solid #dee2e6;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}

.node_type {
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
}

.onlySubscription{
  background: #6125af;
  color: white;
  padding: 7px 40px !important;
  border-radius: 35px;
}

.type_group {
  display: flex;
  align-items: center;
  background-color: #efe4ff;
  width: -moz-fit-content;
  width: fit-content;
  justify-content: space-between;
  margin: 20px 0;
  padding: 7px 8px;
  border-radius: 35px;
  font-weight: 500;
}

.type_group span {
  cursor: pointer;
}

.type_group span:last-child {
  padding: 0 12px 0 0;
}

.subscription {
  background: #6125af;
  color: white;
  padding: 7px 40px;
  border-bottom-left-radius: 35px;
  border-top-left-radius: 35px;
  margin-right: 10px;
}

.non-subscription {
  background: #6125af;
  color: white;
  padding: 7px 19px !important;
  border-bottom-right-radius: 35px;
  border-top-right-radius: 35px;
}

.type {
  padding: 7px 40px;
}

.video-card {
  height: 100%;
  width: 100%;
  border: none;
  position: relative;
  display: flex;
  justify-content: center;
  /* margin-top: 20px */
}

.video-card img {
  position: relative;
  border-radius: 15px;
  height: 180px;
  object-fit: fill;
}

.video-card p {
  position: absolute;
  bottom: 0;
  background: #00000099;
  color: white;
  margin: 0;
  width: 100%;
  text-align: center;
  padding: 5px 0;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}

.card.border-0 {
  /* background: #f8f9fa; */
  border-radius: 15px;
  width: 230px;
}

.next {
  display: flex;
  justify-content: flex-end;
}

.next p {
  font-weight: 600;
  text-align: right;
  cursor: pointer;
  padding: 2px 7px;
  color: #6c2fbb;
  background: #efe4ff;
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 25px;
  font-size: 12px;
}

.right-section {
  border-left: 1px solid #dee2e6;
}
.profile-title {
  text-align: center;
  padding: 10px 0;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.profile-title img {
  width: 17px;
}

.profile-title span {
  font-size: 15px;
  font-weight: 500;
}

.profileInfo-section {
  background: white;
  border-radius: 16px;
  border: 1px solid #dee2e6;
  padding: 0;
  margin: 17px 0;
}
.welcome {
  border-radius: 16px;
  border: 1px solid #dee2e6;
  height: 350px;
  background: #fff;
  position: relative;
}
.welcome iframe {
  border-radius: 15px;
  position: relative;
}
.welcome-video-col {
  padding: 17px 13px 0;
}

.user-profile-pic {
  width: 90px;
  height: 90px;
  border-radius: 13px;
}
.edit-icon {
  text-align: end;
  padding: 9px 11px 0 0;
}

.edit-icon img {
  cursor: pointer;
}

.information {
  padding: 6px 21px;
  height: 313px;
  overflow: auto;
}
.information h5 {
  font-weight: 600;
}

.information p {
  margin: 3px 0;
  font-size: 15px;
  color: #797979;
}
.information p a {
  text-decoration: underline !important;
  color: #797979;
  font-weight: 500;
}

.topLogoPosition {
  width: -moz-fit-content;
  width: fit-content;
  text-align: center;
}

.topLogoPosition img {
  margin-bottom: 15px;
}

.leftLogoPosition {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.rightLogoPosition {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  flex-direction: row-reverse;
  justify-content: flex-end;
}

.plans {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
}

.vl {
  border-left: 2px solid #e8e8e8;
  height: 25px;
}

.line p,
.dropleft {
  color: #6c2fbb;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}

/* ============= */
.rag-body {
  max-height: 80vh;
  overflow: auto;
}
.rag-list.cdk-drop-list-dragging .rag-box:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.rag-list {
  width: 500px;
  max-width: 100%;
  border: solid 1px #ccc;
  min-height: 60px;
  display: block;
  background: white;
  border-radius: 4px;
  overflow: hidden;
}
.rag-box {
  padding: 10px;
  border-bottom: solid 1px #ccc;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: move;
  background: white;
  font-size: 14px;
  z-index: 99999;
}

.rag-box:last-child {
  border: none;
}
.rag-custom-placeholder {
  background: #ccc;
  border: dotted 3px #999;
  min-height: 110px;
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.rag-img-box {
  width: 100px;
  height: 80px;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  border-radius: 8px;
  background: #f8f9fa;
}

.rag-img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}

.card .card-badge {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background-color: #727272;
  color: #fff;
  padding: 7px 14px;
  border-radius: 15px 0 7px 0;
}

@media (min-width: 1175px) and (max-width: 1440px) {
  .node_type {
    justify-content: space-around;
  }
  .plans {
    position: unset;
  }
}

@media (min-width: 768px) and (max-width: 1174px) {
  .subscription {
    margin-right: 0;
    padding: 7px 9px;
    display: block;
    text-wrap: nowrap;
  }
  .node_type {
    justify-content: space-around;
  }
  .plans {
    position: unset;
    flex-wrap: nowrap !important;
  }
  .type {
    text-wrap: nowrap;
    padding: 7px 5px;
  }
  .non-subscription {
    padding: 7px 3px !important;
  }
  .line p,
  .dropleft {
    text-wrap: nowrap;
  }
}

@media (min-width: 490px) and (max-width: 767px) {
  .node_type{
    flex-direction: column;
    align-items: center;
  }
  .plans{
    position: unset;
    width: 100%;
    margin-bottom: 20px;
    flex-wrap: nowrap !important;
  }
  .subscription {
    margin-right: 5px;
    padding: 7px 9px;
    text-wrap: nowrap;
  }
  .type {
    text-wrap: nowrap;
    padding: 7px 5px;
  }
  .non-subscription {
    padding: 7px 3px !important;
  }
  .line p,
  .dropleft {
    text-wrap: nowrap;
  }
/* 
  .video-card{
    margin-bottom: 20px;
  } */
}

@media (max-width: 425px) {
  .bold-title{
    font-size: 20px
  }

  .template-1-header .seller-profile .user-profile-pic {
    width: 55px !important;
    height: 55px !important;
    border-radius: 13px;
    margin-right: 10px;
  }

   .user-profile-pic {
    width: 65px;
    height: 65px;
    border-radius: 13px;
}

.type_group {
  display: flex;
  align-items: center;
  background-color: #efe4ff;
  width: -moz-fit-content;
  width: fit-content;
  justify-content: space-between;
  margin: 20px 0;
  padding: 7px 25px;
  border-radius: 10px;
  font-weight: 500;
  flex-direction: column;
  gap: 10px;
}

}

@media (min-width: 300px) and (max-width: 489px) {
  .node_type{
    flex-direction: column;
    align-items: center;
  }
  .plans{
    position: unset;
    width: 100%;
    margin-bottom: 20px;
    flex-wrap: nowrap !important;
  }
  .subscription {
    border-radius: 19px;
    padding: 7px 40px;
    margin-top: 3px;
    flex-wrap: nowrap !important;
    text-wrap: nowrap;
    display: block;
  }
  .non-subscription {
    border-radius: 19px;
    padding: 7px 40px;
    margin-top: 3px;
    flex-wrap: nowrap !important;
    text-wrap: nowrap;
    display: block;
  }
  .type {
    text-wrap: nowrap;
    padding: 7px 5px;
  }
  .non-subscription {
    padding: 7px 3px !important;
  }
  .line p,
  .dropleft {
    text-wrap: nowrap;
  }

  .type_group[_ngcontent-serverApp-c283]{
    flex-direction: column;
    padding: 10px;
    border-radius: 10px;
  }
  /* .video-card{
    margin-bottom: 20px;
  } */
}
`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/main-community/bold-template/bold-template.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,uBAAkB;EAAlB,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;EAC5B,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;EACV,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;AACA;EACE,qCAAqC;EACrC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,sDAAsD;AACxD;AACA;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,sDAAsD;AACxD;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;IACf,4BAA4B;EAC9B;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,2BAA2B;EAC7B;EACA;;IAEE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,4BAA4B;EAC9B;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,2BAA2B;EAC7B;EACA;;IAEE,iBAAiB;EACnB;AACF;;;KAGK;AACL;;AAEA;EACE;IACE;EACF;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;EACpB;;GAEC;IACC,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,4BAA4B;EAC9B;EACA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,4BAA4B;IAC5B,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,4BAA4B;IAC5B,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,2BAA2B;EAC7B;EACA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,mBAAmB;EACrB;EACA;;KAEG;AACL","sourcesContent":[".container-fluid {\n  background-color: #f8fafb;\n  padding: 0;\n  border-radius: 15px;\n}\n\n.group-section {\n  background: white;\n  padding: 0 20px;\n  border: 1px solid #dee2e6;\n  border-top-left-radius: 15px;\n  border-top-right-radius: 15px;\n}\n\n.group-section-profile {\n  background: white;\n  padding: 0 20px;\n  border: 1px solid #dee2e6;\n  border-bottom-left-radius: 15px;\n  border-bottom-right-radius: 15px;\n}\n\n.node_type {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  position: relative;\n}\n\n.onlySubscription{\n  background: #6125af;\n  color: white;\n  padding: 7px 40px !important;\n  border-radius: 35px;\n}\n\n.type_group {\n  display: flex;\n  align-items: center;\n  background-color: #efe4ff;\n  width: fit-content;\n  justify-content: space-between;\n  margin: 20px 0;\n  padding: 7px 8px;\n  border-radius: 35px;\n  font-weight: 500;\n}\n\n.type_group span {\n  cursor: pointer;\n}\n\n.type_group span:last-child {\n  padding: 0 12px 0 0;\n}\n\n.subscription {\n  background: #6125af;\n  color: white;\n  padding: 7px 40px;\n  border-bottom-left-radius: 35px;\n  border-top-left-radius: 35px;\n  margin-right: 10px;\n}\n\n.non-subscription {\n  background: #6125af;\n  color: white;\n  padding: 7px 19px !important;\n  border-bottom-right-radius: 35px;\n  border-top-right-radius: 35px;\n}\n\n.type {\n  padding: 7px 40px;\n}\n\n.video-card {\n  height: 100%;\n  width: 100%;\n  border: none;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  /* margin-top: 20px */\n}\n\n.video-card img {\n  position: relative;\n  border-radius: 15px;\n  height: 180px;\n  object-fit: fill;\n}\n\n.video-card p {\n  position: absolute;\n  bottom: 0;\n  background: #00000099;\n  color: white;\n  margin: 0;\n  width: 100%;\n  text-align: center;\n  padding: 5px 0;\n  border-bottom-left-radius: 15px;\n  border-bottom-right-radius: 15px;\n}\n\n.card.border-0 {\n  /* background: #f8f9fa; */\n  border-radius: 15px;\n  width: 230px;\n}\n\n.next {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.next p {\n  font-weight: 600;\n  text-align: right;\n  cursor: pointer;\n  padding: 2px 7px;\n  color: #6c2fbb;\n  background: #efe4ff;\n  width: fit-content;\n  border-radius: 25px;\n  font-size: 12px;\n}\n\n.right-section {\n  border-left: 1px solid #dee2e6;\n}\n.profile-title {\n  text-align: center;\n  padding: 10px 0;\n  border-bottom: 1px solid #dee2e6;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n}\n\n.profile-title img {\n  width: 17px;\n}\n\n.profile-title span {\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.profileInfo-section {\n  background: white;\n  border-radius: 16px;\n  border: 1px solid #dee2e6;\n  padding: 0;\n  margin: 17px 0;\n}\n.welcome {\n  border-radius: 16px;\n  border: 1px solid #dee2e6;\n  height: 350px;\n  background: #fff;\n  position: relative;\n}\n.welcome iframe {\n  border-radius: 15px;\n  position: relative;\n}\n.welcome-video-col {\n  padding: 17px 13px 0;\n}\n\n.user-profile-pic {\n  width: 90px;\n  height: 90px;\n  border-radius: 13px;\n}\n.edit-icon {\n  text-align: end;\n  padding: 9px 11px 0 0;\n}\n\n.edit-icon img {\n  cursor: pointer;\n}\n\n.information {\n  padding: 6px 21px;\n  height: 313px;\n  overflow: auto;\n}\n.information h5 {\n  font-weight: 600;\n}\n\n.information p {\n  margin: 3px 0;\n  font-size: 15px;\n  color: #797979;\n}\n.information p a {\n  text-decoration: underline !important;\n  color: #797979;\n  font-weight: 500;\n}\n\n.topLogoPosition {\n  width: fit-content;\n  text-align: center;\n}\n\n.topLogoPosition img {\n  margin-bottom: 15px;\n}\n\n.leftLogoPosition {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.rightLogoPosition {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n  flex-direction: row-reverse;\n  justify-content: flex-end;\n}\n\n.plans {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.vl {\n  border-left: 2px solid #e8e8e8;\n  height: 25px;\n}\n\n.line p,\n.dropleft {\n  color: #6c2fbb;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n/* ============= */\n.rag-body {\n  max-height: 80vh;\n  overflow: auto;\n}\n.rag-list.cdk-drop-list-dragging .rag-box:not(.cdk-drag-placeholder) {\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n.rag-list {\n  width: 500px;\n  max-width: 100%;\n  border: solid 1px #ccc;\n  min-height: 60px;\n  display: block;\n  background: white;\n  border-radius: 4px;\n  overflow: hidden;\n}\n.rag-box {\n  padding: 10px;\n  border-bottom: solid 1px #ccc;\n  color: rgba(0, 0, 0, 0.87);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n  cursor: move;\n  background: white;\n  font-size: 14px;\n  z-index: 99999;\n}\n\n.rag-box:last-child {\n  border: none;\n}\n.rag-custom-placeholder {\n  background: #ccc;\n  border: dotted 3px #999;\n  min-height: 110px;\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n.rag-img-box {\n  width: 100px;\n  height: 80px;\n  margin-right: 10px;\n  display: flex;\n  justify-content: center;\n  border-radius: 8px;\n  background: #f8f9fa;\n}\n\n.rag-img {\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n}\n\n.card .card-badge {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  background-color: #727272;\n  color: #fff;\n  padding: 7px 14px;\n  border-radius: 15px 0 7px 0;\n}\n\n@media (min-width: 1175px) and (max-width: 1440px) {\n  .node_type {\n    justify-content: space-around;\n  }\n  .plans {\n    position: unset;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1174px) {\n  .subscription {\n    margin-right: 0;\n    padding: 7px 9px;\n    display: block;\n    text-wrap: nowrap;\n  }\n  .node_type {\n    justify-content: space-around;\n  }\n  .plans {\n    position: unset;\n    flex-wrap: nowrap !important;\n  }\n  .type {\n    text-wrap: nowrap;\n    padding: 7px 5px;\n  }\n  .non-subscription {\n    padding: 7px 3px !important;\n  }\n  .line p,\n  .dropleft {\n    text-wrap: nowrap;\n  }\n}\n\n@media (min-width: 490px) and (max-width: 767px) {\n  .node_type{\n    flex-direction: column;\n    align-items: center;\n  }\n  .plans{\n    position: unset;\n    width: 100%;\n    margin-bottom: 20px;\n    flex-wrap: nowrap !important;\n  }\n  .subscription {\n    margin-right: 5px;\n    padding: 7px 9px;\n    text-wrap: nowrap;\n  }\n  .type {\n    text-wrap: nowrap;\n    padding: 7px 5px;\n  }\n  .non-subscription {\n    padding: 7px 3px !important;\n  }\n  .line p,\n  .dropleft {\n    text-wrap: nowrap;\n  }\n/* \n  .video-card{\n    margin-bottom: 20px;\n  } */\n}\n\n@media (max-width: 425px) {\n  .bold-title{\n    font-size: 20px\n  }\n\n  .template-1-header .seller-profile .user-profile-pic {\n    width: 55px !important;\n    height: 55px !important;\n    border-radius: 13px;\n    margin-right: 10px;\n  }\n\n   .user-profile-pic {\n    width: 65px;\n    height: 65px;\n    border-radius: 13px;\n}\n\n.type_group {\n  display: flex;\n  align-items: center;\n  background-color: #efe4ff;\n  width: -moz-fit-content;\n  width: fit-content;\n  justify-content: space-between;\n  margin: 20px 0;\n  padding: 7px 25px;\n  border-radius: 10px;\n  font-weight: 500;\n  flex-direction: column;\n  gap: 10px;\n}\n\n}\n\n@media (min-width: 300px) and (max-width: 489px) {\n  .node_type{\n    flex-direction: column;\n    align-items: center;\n  }\n  .plans{\n    position: unset;\n    width: 100%;\n    margin-bottom: 20px;\n    flex-wrap: nowrap !important;\n  }\n  .subscription {\n    border-radius: 19px;\n    padding: 7px 40px;\n    margin-top: 3px;\n    flex-wrap: nowrap !important;\n    text-wrap: nowrap;\n    display: block;\n  }\n  .non-subscription {\n    border-radius: 19px;\n    padding: 7px 40px;\n    margin-top: 3px;\n    flex-wrap: nowrap !important;\n    text-wrap: nowrap;\n    display: block;\n  }\n  .type {\n    text-wrap: nowrap;\n    padding: 7px 5px;\n  }\n  .non-subscription {\n    padding: 7px 3px !important;\n  }\n  .line p,\n  .dropleft {\n    text-wrap: nowrap;\n  }\n\n  .type_group[_ngcontent-serverApp-c283]{\n    flex-direction: column;\n    padding: 10px;\n    border-radius: 10px;\n  }\n  /* .video-card{\n    margin-bottom: 20px;\n  } */\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
